/**
 * Environment Configuration
 * ຈັດການ environment variables ສຳລັບທັງ dev ແລະ production
 */

/**
 * ກວດສອບວ່າກຳລັງແລ່ນຢູ່ໃນ production mode ຫຼືບໍ່
 */
export const isProduction = import.meta.env.PROD;

/**
 * ກວດສອບວ່າກຳລັງແລ່ນຢູ່ໃນ development mode ຫຼືບໍ່
 */
export const isDevelopment = import.meta.env.DEV;

/**
 * ດຶງ API base URL ໂດຍອັດຕະໂນມັດ
 * - ໃນ development: ໃຊ້ relative path '/api'
 * - ໃນ production: ໃຊ້ relative path '/api' (ເພາະ client ແລະ server ຢູ່ໃນ domain ດຽວກັນ)
 */
export function getApiUrl(): string {
  // ສຳລັບທັງ dev ແລະ production, ໃຊ້ relative path
  // ເພາະ Manus deploy ທັງ frontend ແລະ backend ຢູ່ໃນ domain ດຽວກັນ
  return "/api";
}

/**
 * ດຶງ base URL ຂອງແອັບພລິເຄຊັນ
 */
export function getBaseUrl(): string {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "";
}

/**
 * ດຶງ tRPC endpoint URL
 */
export function getTrpcUrl(): string {
  return `${getApiUrl()}/trpc`;
}
